export const emptyStateComponent_style = {};
